export type RoasterFilter = 'needs' | 'complete' | 'all';

interface RoastersFilterTabsProps {
  value: RoasterFilter;
  onChange: (value: RoasterFilter) => void;
  counts: { needs: number; complete: number; all: number };
}

const TABS: { id: RoasterFilter; label: string }[] = [
  { id: 'needs', label: 'Needs info' },
  { id: 'complete', label: 'Complete' },
  { id: 'all', label: 'All' },
];

export function RoastersFilterTabs({ value, onChange, counts }: RoastersFilterTabsProps) {
  return (
    <div className="flex gap-1 rounded-[10px] bg-wolisho-brown/[0.05] p-1" role="tablist">
      {TABS.map((tab) => {
        const active = value === tab.id;
        const count = counts[tab.id];
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.id)}
            data-testid={`roaster-filter-${tab.id}`}
            className={
              active
                ? 'flex flex-1 items-center justify-center gap-1.5 rounded-md bg-white px-2 py-1.5 text-[12.5px] font-bold text-black shadow-sm'
                : 'flex flex-1 items-center justify-center gap-1.5 rounded-md px-2 py-1.5 text-[12.5px] font-bold text-wolisho-brown/50'
            }
          >
            {tab.label}
            <span
              className={
                active && tab.id === 'needs'
                  ? 'text-[11px] font-bold text-wolisho-red'
                  : active
                    ? 'text-[11px] font-bold text-black/35'
                    : 'text-[11px] font-bold text-wolisho-brown/35'
              }
            >
              {count}
            </span>
          </button>
        );
      })}
    </div>
  );
}
